import {ExperimentNames, hasSeatingPlan, isEcomCheckoutType} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {initiateEcomCheckoutFlow as initiateEcomCheckoutFlowAction} from '../../../../actions/reservation'
import {useAppActions, useAppSelector} from '../../../../hooks/runtime'
import {getEvent, isCheckoutAvailable, isCheckoutButtonDisabled} from '../../../../selectors/event'
import {isCheckoutActionPending, isRequestPending} from '../../../../selectors/pending-requests'
import {FormEntry} from '../../../chunks/form-entry'
import {SeatingPlanModal} from '../../../chunks/seating-plan-modal'
import {RegistrationButtonSkin} from '../../../registration-buttons/registration-button-skin'
import {AddToCart} from './add-to-cart/add-to-cart'
import {TotalPrice} from './total-price'

export const Footer = ({onTicketSelectionError}: {onTicketSelectionError: () => void}) => {
  const {isMobile} = useEnvironment()
  const {experiments} = useExperiments()
  const navigateToEcomCheckoutEnabled = experiments.enabled(ExperimentNames.NavigateToEcomCheckout)

  const event = useAppSelector(getEvent)
  const ecomCheckoutType = isEcomCheckoutType(event)
  const checkoutAvailable = useAppSelector(isCheckoutAvailable)
  const checkoutButtonDisabled = useAppSelector(isCheckoutButtonDisabled)
  const checkoutActionPending = useAppSelector(isCheckoutActionPending)
  const withSeatingPlan = hasSeatingPlan(event)
  const {checkout, openSeatingPlan, initiateEcomCheckoutFlow} = useAppActions()

  const ecomCheckoutActionPending = useAppSelector(state =>
    isRequestPending(state, initiateEcomCheckoutFlowAction.typePrefix),
  )

  const {t} = useTranslation()

  const handleOnClick = () => {
    if (!checkoutAvailable) {
      onTicketSelectionError()
      return
    }

    if (withSeatingPlan) {
      SeatingPlanModal.preload()
      return openSeatingPlan()
    }

    FormEntry.preload()
    return checkout()
  }

  return (
    <>
      {withSeatingPlan ? null : <TotalPrice />}
      {!checkoutButtonDisabled && (
        <RegistrationButtonSkin
          spinner={checkoutActionPending}
          secondary={true}
          minWidth="100%"
          minHeight={isMobile ? undefined : '48px'}
          onClick={handleOnClick}
          dataHook={isMobile ? DH.CHECKOUT : DH.RESERVE_TICKETS_BUTTON}
          narrowerButton={isMobile}
          text={withSeatingPlan ? t('ticketsPicker_selectTickets') : t('checkout')}
        />
      )}
      {navigateToEcomCheckoutEnabled && !withSeatingPlan && (
        <div style={{marginTop: '16px'}}>
          <RegistrationButtonSkin
            spinner={ecomCheckoutActionPending}
            secondary={true}
            minWidth="100%"
            minHeight={isMobile ? undefined : '48px'}
            onClick={() => initiateEcomCheckoutFlow()}
            dataHook={isMobile ? DH.CHECKOUT : DH.RESERVE_TICKETS_BUTTON}
            narrowerButton={isMobile}
            text="Ecom Checkout"
          />
        </div>
      )}
      {navigateToEcomCheckoutEnabled && ecomCheckoutType && (
        <div style={{marginTop: '16px'}}>
          <AddToCart />
        </div>
      )}
    </>
  )
}
